import {
    takeLatest, put, select, call, take
} from 'redux-saga/effects';
import { requestShippingMethods } from 'capi';

import { logError } from '../utils/errorUtils';
import { QUANTITY_FIELD, CURRENCY_FIELD } from '../item/newItemForm';
import { getAddressHash } from '../address/addressModule';
import { applyActivePromoPreCart, RECEIVED_PROMO_REWARDS } from '../promo/promoModule';
import { getCapiClient } from '../session/sessionSelectors';

import { hasProfile, getShippingMethodProfileId } from './shippingSelectors';
import {
    createProfileActive,
    createProfileSuccess,
    createProfileFailed,
    storeProfileMethods,
    profileAlreadyExists,
    GET_SHIPPING_METHOD
} from './shippingModule';



export function* createProfileMethods(profile, requestData) {
    yield put(createProfileActive(profile));

    const capiClient = yield select(getCapiClient);
    try {
        const methods = yield call(requestShippingMethods, capiClient, requestData.toJS());
        yield put(storeProfileMethods(profile, methods));
        yield put(createProfileSuccess(profile, methods));
    } catch (error) {
        logError(error);
        yield put(createProfileFailed(profile, error.response.status, error.message));
    }
}


export function* getShippingMethodSaga({ payload }) {
    yield put(applyActivePromoPreCart(true, true));
    
    yield take(RECEIVED_PROMO_REWARDS);

    let addressHash = payload.get('addressID', null);
    if (!addressHash) {
        addressHash = yield call(getAddressHash, payload);
    }

    const profile = getShippingMethodProfileId(
        addressHash,
        payload.get(QUANTITY_FIELD),
        payload.get(CURRENCY_FIELD),
        payload.get('hasAccessory')
    );

    const methodsExist = yield select(hasProfile, profile);
    if (methodsExist) {
        yield put(profileAlreadyExists(profile));
        return;
    }

    yield call(createProfileMethods, profile, payload);
}

export function* watchGetShippingMethod() {
    yield takeLatest(GET_SHIPPING_METHOD, getShippingMethodSaga);
}
